import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=1831bef9&"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports